import { render, staticRenderFns } from "./referer-table.vue?vue&type=template&id=14f98b73&scoped=true"
import script from "./referer-table.vue?vue&type=script&lang=js"
export * from "./referer-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f98b73",
  null
  
)

export default component.exports